import dynamic from 'next/dynamic';

const Popup = dynamic(() => import('./Popup'));

export default Popup
